<template>
  <div class="element-item-creator">
    <div class="flex items-center mb-3">
      <p class="mb-0 font-lato text-support">Upload New Image</p>
      <button class="close-button ml-auto" @click="$emit('close-click')">
        <v-icon name="times-circle" scale="1" class="mr-1" /> Cancel
      </button>
    </div>

    <form class="mb-0" @submit="onSubmit">
      <!-- Name -->
      <div class="mb-4">
        <label for="name">
          Name
        </label>

        <Input
          v-model.trim="form.name"
          name="name"
          type="text"
          :disabled="saving"
          required
          @blur="onNameBlur"
        />
      </div>

      <!-- Image -->
      <div class="mb-4">
        <label>
          Image
        </label>

        <Uploader
          id="assetUploader"
          :src="form.image.src"
          :edit-mode="true"
          class="mb-4"
          @uploading-complete="onUploadComplete"
          @file-removed="onUploadRemoved('image')"
          @uploading-file="uploading = true"
        />
      </div>

      <!-- Submit -->
      <div class="mt-4">
        <Button
          class="secondary sm"
          :loading="saving"
          :disabled="uploading || !imagesUploaded"
          type="submit"
        >
          {{ saveLabel }}
        </Button>
      </div>
    </form>
  </div>
</template>

<script>
import lowerCase from "lodash.lowercase";
import { Categories } from "@/graphql/queries";
import { CreateImageElement } from "@/graphql/mutations";
import { getAccountId, isAuthError } from "@/lib/auth";
import Input from "@/components/UI/Input";

import Uploader from "@/components/UI/Uploader";

export default {
  name: "ElementItemCreator",
  components: { Input, Uploader },
  props: {
    elementTypes: {
      default: () => [],
      type: Array,
    },
    selectedType: {
      type: String,
      default: "",
    },
  },
  inject: ["DEVELOPMENT"],
  data() {
    return {
      categories: [],
      errors: [],
      form: {
        name: "",
        categoryId: "general",
        description: "",
        image: {
          src: "",
          alt: "",
        },
        price: "0",
        tags: [],
        type: this.selectedType,
      },
      saving: false,
      uploading: false,
    };
  },
  computed: {
    imagesUploaded() {
      return this.form.image.src;
    },
    saveLabel() {
      if (this.uploading) return "Uploading...";

      if (this.saving) return "Saving...";

      return "Save";
    },
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      this.saving = true;
      this.errors = [];

      // Create a copy of the form data...
      const input = JSON.parse(JSON.stringify(this.form));

      try {
        await this.$apollo.mutate({
          mutation: CreateImageElement,
          variables: { input },
          update: (store, { data: { createImageElement } }) => {
            this.$gtm.trackEvent({
              event: "promo-element-added",
              accountId: getAccountId(),
            });

            this.$emit("element-added", createImageElement);
          },
        });
      } catch (error) {
        this.errors.push(error);
        this.$modal.show("error", {
          errors: this.errors,
        });
        this.saving = false;
      }
    },
    onNameBlur() {
      if (!this.form.image.alt) this.form.image.alt = this.form.name;
    },
    onUploadComplete(url) {
      this.form.image.src = url;
      this.uploading = false;
    },
    onUploadRemoved(prop) {
      this.form[prop].src = "";
      this.uploading = false;
    },
  },
};
</script>

<style scoped>
.element-item-creator {
  @apply mb-4 p-4 bg-grey-lightest rounded-lg border border-grey-lighter;
}

.close-button {
  @apply flex items-center text-danger text-sm font-lato;

  svg {
    @apply relative;
    top: 1px;
  }

  &:focus {
    @apply outline-none;
  }
}

>>> .tag-selector .selected-tag,
>>> .tag-selector .selector-option {
  @apply lowercase;
}

>>> .error {
  @apply p-3 mb-4 mt-8;

  .title {
    @apply text-sm mb-2;
  }

  .list {
    @apply mb-0;
  }

  .list-item {
    @apply text-sm;
  }
}
</style>
